"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "coy", {
  enumerable: true,
  get: function get() {
    return _coy.default;
  }
});
Object.defineProperty(exports, "dark", {
  enumerable: true,
  get: function get() {
    return _dark.default;
  }
});
Object.defineProperty(exports, "funky", {
  enumerable: true,
  get: function get() {
    return _funky.default;
  }
});
Object.defineProperty(exports, "okaidia", {
  enumerable: true,
  get: function get() {
    return _okaidia.default;
  }
});
Object.defineProperty(exports, "solarizedlight", {
  enumerable: true,
  get: function get() {
    return _solarizedlight.default;
  }
});
Object.defineProperty(exports, "tomorrow", {
  enumerable: true,
  get: function get() {
    return _tomorrow.default;
  }
});
Object.defineProperty(exports, "twilight", {
  enumerable: true,
  get: function get() {
    return _twilight.default;
  }
});
Object.defineProperty(exports, "prism", {
  enumerable: true,
  get: function get() {
    return _prism.default;
  }
});
Object.defineProperty(exports, "a11yDark", {
  enumerable: true,
  get: function get() {
    return _a11yDark.default;
  }
});
Object.defineProperty(exports, "atomDark", {
  enumerable: true,
  get: function get() {
    return _atomDark.default;
  }
});
Object.defineProperty(exports, "base16AteliersulphurpoolLight", {
  enumerable: true,
  get: function get() {
    return _base16Ateliersulphurpool.default;
  }
});
Object.defineProperty(exports, "cb", {
  enumerable: true,
  get: function get() {
    return _cb.default;
  }
});
Object.defineProperty(exports, "coldarkCold", {
  enumerable: true,
  get: function get() {
    return _coldarkCold.default;
  }
});
Object.defineProperty(exports, "coldarkDark", {
  enumerable: true,
  get: function get() {
    return _coldarkDark.default;
  }
});
Object.defineProperty(exports, "coyWithoutShadows", {
  enumerable: true,
  get: function get() {
    return _coyWithoutShadows.default;
  }
});
Object.defineProperty(exports, "darcula", {
  enumerable: true,
  get: function get() {
    return _darcula.default;
  }
});
Object.defineProperty(exports, "dracula", {
  enumerable: true,
  get: function get() {
    return _dracula.default;
  }
});
Object.defineProperty(exports, "duotoneDark", {
  enumerable: true,
  get: function get() {
    return _duotoneDark.default;
  }
});
Object.defineProperty(exports, "duotoneEarth", {
  enumerable: true,
  get: function get() {
    return _duotoneEarth.default;
  }
});
Object.defineProperty(exports, "duotoneForest", {
  enumerable: true,
  get: function get() {
    return _duotoneForest.default;
  }
});
Object.defineProperty(exports, "duotoneLight", {
  enumerable: true,
  get: function get() {
    return _duotoneLight.default;
  }
});
Object.defineProperty(exports, "duotoneSea", {
  enumerable: true,
  get: function get() {
    return _duotoneSea.default;
  }
});
Object.defineProperty(exports, "duotoneSpace", {
  enumerable: true,
  get: function get() {
    return _duotoneSpace.default;
  }
});
Object.defineProperty(exports, "ghcolors", {
  enumerable: true,
  get: function get() {
    return _ghcolors.default;
  }
});
Object.defineProperty(exports, "hopscotch", {
  enumerable: true,
  get: function get() {
    return _hopscotch.default;
  }
});
Object.defineProperty(exports, "materialDark", {
  enumerable: true,
  get: function get() {
    return _materialDark.default;
  }
});
Object.defineProperty(exports, "materialLight", {
  enumerable: true,
  get: function get() {
    return _materialLight.default;
  }
});
Object.defineProperty(exports, "materialOceanic", {
  enumerable: true,
  get: function get() {
    return _materialOceanic.default;
  }
});
Object.defineProperty(exports, "nord", {
  enumerable: true,
  get: function get() {
    return _nord.default;
  }
});
Object.defineProperty(exports, "pojoaque", {
  enumerable: true,
  get: function get() {
    return _pojoaque.default;
  }
});
Object.defineProperty(exports, "shadesOfPurple", {
  enumerable: true,
  get: function get() {
    return _shadesOfPurple.default;
  }
});
Object.defineProperty(exports, "synthwave84", {
  enumerable: true,
  get: function get() {
    return _synthwave.default;
  }
});
Object.defineProperty(exports, "vs", {
  enumerable: true,
  get: function get() {
    return _vs.default;
  }
});
Object.defineProperty(exports, "vscDarkPlus", {
  enumerable: true,
  get: function get() {
    return _vscDarkPlus.default;
  }
});
Object.defineProperty(exports, "xonokai", {
  enumerable: true,
  get: function get() {
    return _xonokai.default;
  }
});

var _coy = _interopRequireDefault(require("./coy"));

var _dark = _interopRequireDefault(require("./dark"));

var _funky = _interopRequireDefault(require("./funky"));

var _okaidia = _interopRequireDefault(require("./okaidia"));

var _solarizedlight = _interopRequireDefault(require("./solarizedlight"));

var _tomorrow = _interopRequireDefault(require("./tomorrow"));

var _twilight = _interopRequireDefault(require("./twilight"));

var _prism = _interopRequireDefault(require("./prism"));

var _a11yDark = _interopRequireDefault(require("./a11y-dark"));

var _atomDark = _interopRequireDefault(require("./atom-dark"));

var _base16Ateliersulphurpool = _interopRequireDefault(require("./base16-ateliersulphurpool.light"));

var _cb = _interopRequireDefault(require("./cb"));

var _coldarkCold = _interopRequireDefault(require("./coldark-cold"));

var _coldarkDark = _interopRequireDefault(require("./coldark-dark"));

var _coyWithoutShadows = _interopRequireDefault(require("./coy-without-shadows"));

var _darcula = _interopRequireDefault(require("./darcula"));

var _dracula = _interopRequireDefault(require("./dracula"));

var _duotoneDark = _interopRequireDefault(require("./duotone-dark"));

var _duotoneEarth = _interopRequireDefault(require("./duotone-earth"));

var _duotoneForest = _interopRequireDefault(require("./duotone-forest"));

var _duotoneLight = _interopRequireDefault(require("./duotone-light"));

var _duotoneSea = _interopRequireDefault(require("./duotone-sea"));

var _duotoneSpace = _interopRequireDefault(require("./duotone-space"));

var _ghcolors = _interopRequireDefault(require("./ghcolors"));

var _hopscotch = _interopRequireDefault(require("./hopscotch"));

var _materialDark = _interopRequireDefault(require("./material-dark"));

var _materialLight = _interopRequireDefault(require("./material-light"));

var _materialOceanic = _interopRequireDefault(require("./material-oceanic"));

var _nord = _interopRequireDefault(require("./nord"));

var _pojoaque = _interopRequireDefault(require("./pojoaque"));

var _shadesOfPurple = _interopRequireDefault(require("./shades-of-purple"));

var _synthwave = _interopRequireDefault(require("./synthwave84"));

var _vs = _interopRequireDefault(require("./vs"));

var _vscDarkPlus = _interopRequireDefault(require("./vsc-dark-plus"));

var _xonokai = _interopRequireDefault(require("./xonokai"));